import { useState, useEffect, useRef } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faCircleNotch, faAngleLeft, faCheck } from '@fortawesome/free-solid-svg-icons'
import Select from "react-select";
import Modal from 'react-modal';
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';
import { QRCodeSVG } from 'qrcode.react';
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';

// FILE UPLOAD
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)
   
function Deposit({modalIsOpen, setIsOpen, route = "asset", copy, pprice}) {
  const { user } = useUser();
  const [modalIsOpen1, setIsOpen1] = useState(false);
  const [modalIsOpen2, setIsOpen2] = useState(false);
  const [modalIsOpen3, setIsOpen3] = useState(false);
  const [files, setFiles] = useState([])
  const [fileName, setFileName] = useState()
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "#708bc20d" : isFocused ? "#708bc20d" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [methodoptions, setMethodoptions] = useState([]);
  const [type, setType] = useState("crypto");
  const [method, setMethod] = useState();
  const [price, setPrice] = useState();
  const [symbol, setSymbol] = useState();
  const [address, setAddress] = useState();
  const [amount, setAmount] = useState();
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [qrCode, setQrCode] = useState('');
  const [network, setNetwork] = useState('');
  const [networklist, setNetworkList] = useState([]);
  const [memo, setMemo] = useState('');
  const [memo_address, setMemo_address] = useState('');
  
  const handleCopy = async () => {
    if (!address) return;
    try {
      await navigator.clipboard.writeText(address);
      toast.success('Copied to clipboard');
    } catch (err) {
      console.error("Failed to copy: ", err);
      toast.error("Failed to copy address");
    }
  };
  const handleCopy1 = async () => {
      if (!memo_address) return;
      try {
          await navigator.clipboard.writeText(memo_address);
          toast.success('Copied to Clipboard!')
      } catch (err) {
          console.error("Failed to copy: ", err);
      }
  };
  const [manual, setManual] = useState(0);
  useEffect(() => {
    if(pprice && price){
      var amount = (Number(pprice) / Number(price)).toFixed('4');
      setAmount(amount);
    }
  }, [price]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const adminRes = await fetch(
          `${process.env.REACT_APP_API_URL}controller/fetch.controller.php`,
          {
            credentials: "include",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ fetchadmin: true })
          }
        );
        const adminData = await adminRes.json();
        if (adminData.status !== "success") return;
        const manualD = adminData.adminData.manual_deposit;
        setManual(manualD);
        let action = "";
        if (manualD == "1") {
          switch (route) {
            case "Signal":
              action = "fetchsiaddress";
              break;
            case "Subscription":
              action = "fetchsaddress";
              break;
            case "Copy Expert":
              action = "fetchcaddress";
              break;
            case "Stock":
              action = "fetchstaddress";
              break;
            default:
              action = "fetchaddress";
          }
        } else {
          action = "fetchaddress";
        }
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}controller/fetch.controller.php`,
          {
            credentials: "include",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ [action]: true })
          }
        );
        const data = await res.json();
        if (data.status === "success") {
          const methodop = data.address.map(address => ({
            value: address.value,
            logo: address.logo,
            symbol: address.symbol,
            price: address.price,
            network: JSON.parse(address.network),
            address: address.address,
            label: (
              <>
                <img
                  src={address.logo}
                  alt={address.symbol}
                  width="20"
                  style={{ marginRight: 5 }}
                />
                {address.value}
              </>
            )
          }));
          setMethodoptions(methodop);
        }
      } catch (err) {
        console.error("Error fetching deposit wallet:", err);
      }
    };
    fetchData();
  }, [user, route]);

  const prevDependencies = useRef({ type, method, amount, fileName });
  useEffect(() => {
    const { type: prevType, method: prevMethod, amount: prevAmount, fileName: prevFileName } = prevDependencies.current;
    if (type !== prevType || method !== prevMethod || amount !== prevAmount || fileName !== prevFileName) {
      if (type && method && amount && fileName) {
        setDisable(false);
      } else {
        setDisable(true);
      }
      prevDependencies.current = { type, method, amount, fileName };
    }
  }, [type, method, amount, fileName]);
  const ValidateDeposit = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/deposit.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        [route === "asset" ? "btn_deposit" :route === "Copy Expert" ? "btn_cdeposit" : "btn_sdeposit"]: true,
        amount: amount,
        proof: fileName,
        method: method,
        type: route,
        symbol: symbol,
        copy: copy,
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setLoading(false);
        setIsOpen(false);
        toast.success(data.result);
        setTimeout(() => {
          window.location.href = "dashboard";
        }, 2000);
      }else{
        toast.error(data.message);
        setLoading(false);
      }
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }

  const ValidateDeposit1 = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/deposit.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        btn_stdeposit: true,
        amount: amount,
        proof: fileName,
        method: method,
        type: route,
        symbol: symbol,
        stock_name: localStorage.getItem('stock.name')  || '',
        stock_symbol: localStorage.getItem('stock.symbol')  || '',
        stock_price: localStorage.getItem('stock.price')  || '',
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setLoading(false);
        setIsOpen(false);
        toast.success(data.result);
        setTimeout(() => {
          window.location.href = "dashboard";
        }, 2000);
      }else{
        toast.error(data.message);
        setLoading(false);
      }
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }

  const ValidateNetwork = (allnetwork) => {
    if (!Array.isArray(allnetwork) || allnetwork.length === 0) {
      setNetworkList([]);
      setNetwork('');
      setAddress('');
      setQrCode('');
      return;
    }
    const options = allnetwork.map(net => ({ value: net, label: net }));
    setNetworkList(options);
    setNetwork('');
    setAddress('');
    setQrCode('');
  }
  const UpdateAddress = (networkValue) => {
    if (!method || !networkValue || !Array.isArray(methodoptions)) return;
    const match = methodoptions.find(m => (m.symbol === method || m.value === method));
    if (!match) {
      setAddress('');
      setQrCode('');
      setNetwork('');
      return;
    }
    let addrMap = {};
    try {
      addrMap = typeof match.address === 'string' ? JSON.parse(match.address) : match.address;
    } catch (err) {
      addrMap = {};
    }
    const addr = addrMap[networkValue] || '';
    setAddress(addr);
    setQrCode(addr);

    let action;
    if(manual == "1" && route == 'Signal'){
      action = "fetchsimemo";
    }else if(manual == "1" && route == 'Subscription'){
      action = "fetchsmemo";
    }else if(manual == "1" && route == 'Copy Expert'){
      action = "fetchcmemo";
    }else if(manual == "1" && route == 'Stock'){
      action = "fetchstmemo";
    }else{
      action = "fetchmemo";
    }
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ [action]: true, coin : match.symbol, network :network })
    })
    .then(response =>  response.json())
    .then(data => {
      if (data.status === "success") {
        setMemo(data.address.memo); 
        setMemo_address(data.address.memo_address); 
      }else{
        setMemo(false); 
        setMemo_address(""); 
      }
    })
    .catch(err => {
    })
  }
  return (
    <>
    <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        shouldCloseOnOverlayClick={true} 
        closeTimeoutMS={100}
        className="shortmode"
    >
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-semibold text-white" style={{fontSize: '14px'}}>Make a deposit</p>
            <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
        </div>
        <p className="text-gray mt-3 mb-4" style={{fontSize: '13px'}}>To make a deposit, choose your preferred method, and click on the continue button.</p>
        <p className="text-gray mb-2" style={{fontSize: '12px'}}>Payment options</p>
        <div className="rounded-3 mb-2" style={{backgroundColor:'#708bc20d',cursor:'pointer',padding:'12px 10px',border: type=="crypto"?'1px solid #4763f0':'none'}} onClick={()=>setType("crypto")}>
          <p className={`mb-0 fw-semibold ${type=="crypto"?'text-white':'text-gray'}`} style={{fontSize:'14px'}}>Crypto</p>
        </div>
        <div className="rounded-3 mb-2" style={{backgroundColor:'#708bc20d',cursor:'pointer',padding:'12px 10px',border: type=="bank"?'1px solid #4763f0':'none'}} onClick={()=>setType("bank")}>
          <p className={`mb-0 fw-semibold ${type=="bank"?'text-white':'text-gray'}`} style={{fontSize:'14px'}}>Bank transfer</p>
        </div>
        <div className="rounded-3 mb-2" style={{backgroundColor:'#708bc20d',cursor:'pointer',padding:'12px 10px',border: type=="paypal"?'1px solid #4763f0':'none'}} onClick={()=>setType("paypal")}>
          <p className={`mb-0 fw-semibold ${type=="paypal"?'text-white':'text-gray'}`} style={{fontSize:'14px'}}>Paypal</p>
        </div>
        <div className="rounded-3 mb-2" style={{backgroundColor:'#708bc20d',cursor:'pointer',  padding:'12px 10px',border: type=="skrill"?'1px solid #4763f0':'none'}} onClick={()=>setType("skrill")}>
          <p className={`mb-0 fw-semibold ${type=="skrill"?'text-white':'text-gray'}`} style={{fontSize:'14px'}}>Skrill</p>
        </div>
        <div className={`myBtn w-100 text-center mt-3`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={() => {(type=="crypto") ? setIsOpen1(true) : setIsOpen2(true)}}>Continue</div>
    </Modal>
    <Modal
        isOpen={modalIsOpen2}
        onRequestClose={() => setIsOpen2(false)}
        shouldCloseOnOverlayClick={true} 
        closeTimeoutMS={100}
        className="shortmode"
    >
        <div className="d-flex align-items-center justify-content-between">
            <div></div>
            <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen2(false)} />
        </div>
        <div className="d-flex align-items-center justify-content-center">
          <img src="uploads/unavailable.png" alt="Unavailable Payment" style={{width: '200px'}}/>
        </div>
        <p className="fw-semibold mb-2 mt-3 text-center" style={{fontSize: '16px'}}>Payment Method Unavailable</p>
        <p className="text-gray text-center" style={{fontSize: '13px'}}>Unfortunately, this payment option is currently not available. Please choose a different method to proceed with your deposit.</p>
        <div className={`myBtn w-100 text-center mt-4`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={() => setIsOpen2(false)}>Close</div>
    </Modal>
    <Modal
        isOpen={modalIsOpen1}
        onRequestClose={() => setIsOpen1(false)}
        shouldCloseOnOverlayClick={true} 
        closeTimeoutMS={100}
        className="shortmode"
    >
        <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <FontAwesomeIcon className="text-gray me-2" icon={faAngleLeft} style={{fontSize: '10px'}} onClick={() => setIsOpen1(false)} />
              <p className="mb-0 fw-semibold text-white" style={{fontSize: '14px'}}></p>
            </div>
            <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen1(false)} />
        </div>
        <p className="text-gray mt-2 mb-3" style={{fontSize: '13px'}}>To proceed, select your token and network, make payment to the address shown and click on the continue button.</p>
        <div className="d-flex" style={{gap:'12px'}}>
          <div className="d-flex flex-column align-items-center mt-2" style={{gap:'4px'}}>
            <div className="d-flex align-items-center justify-content-center rounded-circle" style={{width:'18px',height:'18px',backgroundColor:'#4763f0',border:'1px solid #4763f0'}}>
              <p className="mb-0 fw-semibold" style={{fontSize:'10px'}}>{!method?'1':<FontAwesomeIcon icon={faCheck} style={{fontSize: '10px'}}/>}</p>
            </div>
            <div style={{width:'2px',backgroundColor:'#4763f0',height:'50px'}}></div>
            <div className="d-flex align-items-center justify-content-center rounded-circle" style={{width:'18px',height:'18px',backgroundColor:method?'#4763f0':'transparent',border:'1px solid #4763f0'}}>
              <p className="mb-0 fw-semibold" style={{fontSize:'10px'}}>{!address?'2':<FontAwesomeIcon icon={faCheck} style={{fontSize: '10px'}}/>}</p>
            </div>
            <div style={{width:'2px',backgroundColor:method?'#4763f0':'#708bc214',height:'50px'}}></div>
            <div className="d-flex align-items-center justify-content-center rounded-circle" style={{width:'18px',height:'18px',backgroundColor:address?'#4763f0':'transparent',border:'1px solid #4763f0'}}>
              <p className="mb-0 fw-semibold" style={{fontSize:'10px'}}>{!address?'3':<FontAwesomeIcon icon={faCheck} style={{fontSize: '10px'}}/>}</p>
            </div>
            <div style={{width:'2px',backgroundColor:address?'#4763f0':'#708bc214',height:!address?'55px':'240px'}}></div>
            <div className="d-flex align-items-center justify-content-center rounded-circle" style={{width:'18px',height:'18px',backgroundColor:address?'#4763f0':'transparent',border:'1px solid #4763f0'}}>
              <p className="mb-0 fw-semibold" style={{fontSize:'10px'}}>4</p>
            </div>
            <div style={{width:'2px',backgroundColor:address?'#4763f0':'#708bc214',height:'30px'}}></div>
          </div>
          <div style={{flexGrow:'1'}}>
              <label className="fw-semibold mb-1" style={{fontSize: '12px'}}>Select token to deposit</label>
              <Select  
                  options={methodoptions} 
                  value={methodoptions.find((opt) => opt.value === method)}
                  onChange={(selected) => {
                      setMethod(selected.value);
                      setPrice(selected.price);
                      setSymbol(selected.symbol);
                      setAddress('');
                      setQrCode('');
                      setNetwork('');
                      setMemo(false); 
                      setMemo_address(''); 
                      setNetworkList([]);
                      ValidateNetwork(selected.network);
                  }}
                  isSearchable
                  styles={darkThemeStyles}
                  className="w-full"
              />
              <label className="fw-semibold mb-1 mt-2" style={{fontSize: '12px'}}>Select network</label>
              <Select 
                  options={networklist}
                  value={networklist.find((opt) => opt.value === network) || null}
                  onChange={(selected) => {
                  UpdateAddress(selected.value);
                  setNetwork(selected.value);
                  }}
                  isSearchable
                  styles={darkThemeStyles}
                  className="w-full"
              />
              <label className="fw-semibold mb-1 mt-2" style={{fontSize: '12px'}}>Deposit details</label> 
              <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                  <input 
                      type="text"
                      readOnly
                      className="inputNone"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                  />
                  <div className="fw-bold text-white" style={{backgroundColor: '#708bc20d', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}} onClick={handleCopy}>Copy</div>
              </div>
              {memo && (
              <>
              <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>{symbol} Memo:</label>
              <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                  <input 
                    type="text"
                    readOnly
                    className="inputNone"
                    value={memo_address}
                  />
                  <div className="fw-bold text-white" style={{backgroundColor: '#708bc20d', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}} onClick={handleCopy1}>Copy</div>
              </div>
              </>
              )}
              {qrCode && (
              <div className="mt-3 d-flex flex-column justify-content-center align-items-center">
                  <h6 className="text-center fw-semibold mb-1" style={{fontSize:'12px'}}>Scan Qr Code</h6>
                  <div className="mycard p-2">
                  <QRCodeSVG
                      value={qrCode}
                      size={120}
                      bgColor="#ffffff"
                      fgColor="#000000"
                      level="M"
                  />
                  </div>
                  <p className="mb-0 text-center" style={{fontSize: '10px'}}>
                      Wallet Address: {qrCode}
                  </p>
              </div>
              )}
              <label className="text-gray fw-semibold mb-1 mt-3" style={{fontSize: '12px'}}>Deposit confirmation</label> 
              <label className="text-gray mb-0" style={{fontSize: '13px'}}>Click on the ‘continue’ button at the bottom to proceed to deposit confirmation</label> 
          </div>
        </div>
        <div className={`myBtn w-100 text-center mt-3 ${(!method || !address) ? 'disabled' : null}`} style={{paddingTop: '12px',paddingBottom:'12px',fontSize:'14px'}} onClick={()=>{if(method && address){setIsOpen3(true);setIsOpen1(false);}}}>Continue</div>
    </Modal>
    <Modal
      isOpen={modalIsOpen3}
      onRequestClose={() => setIsOpen3(false)}
      shouldCloseOnOverlayClick={true} 
      closeTimeoutMS={100}
      className="shortmode"
    >
      <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <FontAwesomeIcon className="text-gray me-2" icon={faAngleLeft} style={{fontSize: '10px'}} onClick={() => setIsOpen3(false)} />
            <p className="mb-0 fw-semibold text-white" style={{fontSize: '14px'}}>Confirmation</p>
          </div>
          <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen3(false)} />
      </div>
      <label className="fw-semibold mt-2 mb-1" style={{fontSize: '12px'}}>Amount:</label>
      <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
          <input 
              type="number"
              placeholder="0.00"
              className="inputNone"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              readOnly = {(copy || route == "Stock") ? true : false}
              step="0.01"
          />
          <div
              className="fw-bold text-white d-flex align-items-center"
              style={{
              backgroundColor: '#708bc20d',
              borderRadius: '4px',
              padding: '6px',
              fontSize: '14px'
              }}
          >
              {symbol}
          </div>
      </div>
      <label className="fw-semibold mt-3 mb-1" style={{fontSize: '12px'}}>Payment proof:</label>
      <FilePond
        files={files}
        onupdatefiles={setFiles}
        allowMultiple={false}
        maxFiles={1}
        name="file"
        labelIdle="Upload Proof"
        acceptedFileTypes={['image/*', 'application/pdf']}
        server={{
        process: (fieldName, file, metadata, load, error, progress, abort) => {
            const formData = new FormData();
            formData.append("file", file);
            const request = new XMLHttpRequest();
            request.open("POST", `${process.env.REACT_APP_API_URL}controller/upload.php`);
            request.upload.onprogress = (e) => {
            progress(e.lengthComputable, e.loaded, e.total);
            };
            request.onload = () => {
            try {
                const res = JSON.parse(request.responseText);
                if (res.success) {
                    setFileName(res.filename);
                    load(res.filename);
                } else {
                    error(res.error || "Upload failed");
                }
            } catch (err) {
                error("Invalid response");
            }
            };
            request.onerror = () => {
            error("Upload error");
            };
            request.send(formData);
            return {
            abort: () => {
                request.abort();
                abort();
            }
            };
        },
        revert: (serverId, load, error) => {
            if (!fileName) {
                load();
                return;
            }
            fetch(`${process.env.REACT_APP_API_URL}controller/delete.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ filename: fileName })
            })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                setFileName("");
                setFiles([]);
                load();
                } else {
                error(data.error || "Failed to delete file");
                }
            })
            .catch(() => {
                error("Delete request failed");
            });
        }
        }}
      />
      <div className="mt-4 d-flex align-items-center justify-content-between">
        <p className="mb-0 text-gray" style={{fontSize:'13px'}}>Total deposit value</p>
        <p className="mb-0 fw-bold" style={{fontSize:'13px'}}>
          {amount && parseFloat(amount) > 0 ? `${getCurrencySymbol(user?.currency)}${formatCurrency(amount * price)}` : '0.00'}
        </p>
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <p className="mb-0 text-gray" style={{fontSize:'12px'}}>Deposit Address</p>
        <p className="mb-0 text-truncate" style={{fontSize:'12px', maxWidth: '200px'}} title={address}>
          {address ? `${address.substring(0, 6)}...${address.substring(address.length - 4)}` : ''}
        </p>
      </div>
      <div className={`mt-1 myBtn w-100 text-center ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px',fontSize:'14px'}} onClick={!disable ? 
        (route == 'Stock' ? ValidateDeposit1 : ValidateDeposit) : null}>
        {loading?
          <FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:
          "Deposit"
        }
      </div>
    </Modal>
    </>
  )
}
export default Deposit